import { Injectable, Inject } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { User } from '../models/user';
import {TokenHttp} from './token-http';
import {PagingModel} from '../models/paging-model';
import {KvItem} from '../models/kv-item';
import {KvStringItem} from '../models/kv-string-item';
import {AdminUserResponse} from '../models/admin-user-response';

@Injectable()
export class UserService {

  constructor(private http: TokenHttp,
              @Inject('ApplicationConfig') private config: any) { }

  getUsers(paging: PagingModel): Observable<AdminUserResponse> {
    return this.http.post(this.config.apiEndpoint + '/api/account/pagedusers', paging)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getRoles(): Observable<KvItem[]> {
    return this.http.get(this.config.apiEndpoint + '/api/account/rolesds')
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  loadUser(usr: string): Observable<User> {
    return this.http.post(this.config.apiEndpoint + '/api/account/user', new KvStringItem(usr))
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  saveUser(usr: User): Observable<string> {
    return this.http.post(this.config.apiEndpoint + '/api/account/updateuser', usr)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  createUser(usr: User): Observable<string> {
    return this.http.post(this.config.apiEndpoint + '/api/account/create', usr)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  checkIfUsernameExists(username: string): Observable<boolean> {
    return this.http.post(this.config.apiEndpoint + '/api/account/checkusername', new KvItem(0, username))
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  checkIfEmailExists(email: string): Observable<boolean> {
    return this.http.post(this.config.apiEndpoint + '/api/account/checkemail', new KvItem(0, email))
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  toggleEnabled(uid: string): Observable<boolean> {
    return this.http.get(this.config.apiEndpoint + '/api/account/toggleenabled?id=' + uid)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  registerMfa(username: string): Observable<boolean> {
    return this.http.get(this.config.apiEndpoint + '/api/mfa/register?userName=' + username)
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/services/user.ts